module.exports = __webpack_public_path__ + "img/tarifas.0d32a9cf.svg";